module.exports = __webpack_public_path__ + "static/media/ggc5k.06ca2e46.gpx";